// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__NDkh9","active":"ProgressBar_active__YQEHT","completed":"ProgressBar_completed__4hdv1"};